// wont work with .co.uk or other extensions with several dots
const hostname = window.location.hostname.split('.');
const currentDomain = window.location.hostname === 'localhost' ?
	'localhost' : hostname[hostname.length - 2] + '.' + hostname[hostname.length - 1];

type cookie = {
	name?: string,
	value?: string,
}

const strToChunks = (str: string, size: number = 4000): string[] => {
	return str.match(new RegExp(`.{1,${size}}`, 'g')) || [];
};

const getCookies = (): cookie[] => document.cookie.split(';').map(str => {
	const cookie = str.split('=');
	return {
		name: cookie[0]?.[0] === ' ' ? cookie[0].substring(1) : cookie[0],
		value: cookie[1],
	};
});

const getSize = (cookies: cookie[], name: string) => {
	const size = cookies.find(({ name: cname }) => cname === name + '-size');
	return Number(size?.value);
};

function getItem(name: string) {
	const cookies = getCookies();
	const size = getSize(cookies, name);
	let result = '';
	for (let i = 0; i < size; i++) {
		const chunk = cookies.find(({ name: cname }) => cname === `${name}[${i}]`);
		if (!chunk) {
			removeItem(name);
			throw new Error('Missing cookie chunk.');
		}
		result += chunk.value;
	}
	return result;
}

function setItem(name: string, value: string, {
	domain = currentDomain,
	path = '/',
}: {
	domain?: string;
	path?: string;
} = {}) {
	removeItem(name, { domain, path });
	const chunks = strToChunks(value);
	const now = new Date();
	const expires = new Date();
	expires.setTime(now.getTime() + 3600000 * 24 * 7);
	chunks.forEach((chunk, index) => {
		document.cookie = `${name}[${index}]=${(chunk || '')}; Path=${path}; Domain=${domain}; Expires=${expires.toString()};`;
	});
	document.cookie = `${name}-size=${chunks.length}; Path=${path}; Domain=${domain}; Expires=${expires.toString()};`;
}

function removeItem(name: string, {
	domain = currentDomain,
	path = '/',
}: {
	domain?: string;
	path?: string;
} = {}) {
	const cookies = getCookies();
	const size = getSize(cookies, name);
	document.cookie = `${name}-size=; Path=${path}; Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	for (let i = 0; i < size; i++) {
		document.cookie = `${name}[${i}]=; Path=${path}; Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	}
}

export default {
	setItem,
	getItem,
	removeItem,
};
